import { difference } from 'underscore';

import { BriefingSendAtModel } from './briefing-send-at.model';
import { BriefingStatusEnum, briefingStatusMapFromApi, briefingStatusMapToApi } from '../../../Common/MonitorShared/enum/briefing-status.enum';
import { BriefingApiModel } from '../../../api/briefings/model/briefing-api.model';
import { BriefingBlockApiModel } from '../../../api/briefings/model/briefing-block-api.model';
import { BriefingBlockTypeApiEnum } from '../../../api/briefings/enum/briefing-block-type-api.enum';
import { briefingBlockTypeEnumToBlockTypeMap } from './briefings-block-types.model';
import {
    BriefingBlockTypeEnum,
    briefingBlockTypeEnumFromApi,
    briefingBlockTypeEnumToApi,
    columnNumberToBriefingBlockTypeMap
} from '../enums/briefing-block-type.enum';
import { BlockModel, LayoutBlockTypesEnum } from '../../../Common/PageBuilder/models/block.model';
import { TextDisplayElementModel } from '../../../Common/PageBuilder/models/text-display-element.model';
import { BriefingTextDisplayElementApiModel } from '../../../api/briefings/model/briefing-text-display-element-api.model';
import { BriefingTitleDisplayElementApiModel } from '../../../api/briefings/model/briefing-title-display-element-api.model';
import { BriefingImageDisplayElementApiModel } from '../../../api/briefings/model/briefing-image-display-element-api.model';
import { DateDisplayElementModel } from '../../../Common/PageBuilder/models/date-display-element.model';
import { BriefingDateDisplayElementApiModel } from '../../../api/briefings/model/briefing-date-display-element-api.model';
import { SearchCriteriaDateQueryModel } from '../../../api/mentions/model/search-criteria-date-query.model';
import { DateQueryModel } from '../../../Common/Forms/models/date-query.model';
import { DynamicMentionListDisplayElementModel } from './dynamic-mention-list-display-element.model';
import { BriefingAutomaticMentionListDisplayElementApiModel } from '../../../api/briefings/model/briefing-automatic-mention-list-display-element-api.model';
import { CuratedMentionListDisplayElementModel } from './curated-mention-list-display-element.model';
import { BriefingCuratedMentionListDisplayElementApiModel } from '../../../api/briefings/model/briefing-curated-mention-list-display-element-api.model';
import { BriefingOrganizeByEnum, briefingOrganizeByMapFromApi, briefingOrganizeByMapToApi } from '../enums/briefing-organize-by.enum';
import { BriefingTypeEnum } from '../enums/briefing-type.enum';
import { MonitoringSeriesTypeEnum } from '../../Shared/enums/monitoring-series-type.enum';
import { BriefingGeneralStylesModel } from './briefing-general-styles.model';
import { TimeHelper } from '../../../Common/Forms/helpers/time.helper';
import { TableOfContentDisplayElementModel } from './table-of-content-display-element.model';
import { BriefingTableOfContentDispalyElementApiModel } from '../../../api/briefings/model/briefing-table-of-content-display-element-api.model';

import { BriefingStyleStateEnum } from '../../../Common/MonitorShared/enum/briefing-style-state.enum';
import { StyleStateEnum } from '../../../Common/PageBuilder/enums/style-state.enum';
import { defaultBriefingStyles } from '../../Shared/models/default-briefing-styles.model';
import { DeliveryOptionModel } from '../../Shared/models/delivery-option.model';
import { deliveryOptionsEnum } from '../../Shared/enums/delivery-options.enum';
import { BriefingTextDisplayElementModel } from './briefing-text-display-element.model';
import { AuditableModel } from '../../../Common/Misc/models/auditable.model';
import { AlertTypeEnum } from '../../../Common/MonitorShared/enum/alert-type.enum';
import { BriefingFeedModel } from './briefing-feed.model';
import { RSSFeed } from '../../Shared/models/rss-feed.model';
import {
    mentionSourceApiTypesEnumToMonitoringSeriesTypeEnum,
    monitoringSeriesTypeEnumToMentionSourceApiTypesEnum
} from '../../../api/mentions/enum/mention-source-api-types.enum';
import { LayoutBlock } from '../../../Common/PageBuilder/models/layout-block.model';
import { LayoutDisplayElement } from '@Common/PageBuilder/models/layout-display-element.model';
import { AnalysisDisplayElementModel } from './briefing-analysis-display-element.model';
import { BriefingAnalysisDisplayElementApiModel } from '@api/briefings/model/briefing-analysis-display-element-api.model';
import { BriefingStatusApiEnum } from '../../../api/briefings/enum/briefing-status-api.enum';

import { DividerDisplayElementModel } from '../../../Common/PageBuilder/models/divider-display-element.model';
import { BriefingDividerDisplayElementApiModel } from '../../../api/briefings/model/briefing-divider-display-element-api.model';
import { BriefingImageDisplayElementModel } from '../../../Common/PageBuilder/models/briefing-image-display-element.model';
import { LinkDisplayElementModel } from '../../../Common/PageBuilder/models/link-display-element.model';
import { BriefingLinkDisplayElementApiModel } from '../../../api/briefings/model/briefing-link-display-element-api.model';
import { BriefingChartDisplayElementApiModel } from '../../../api/briefings/model/briefing-chart-display-element-api.model';
import { BriefingChartDisplayElementModel } from '../../../Common/PageBuilder/models/briefing-chart-display-element.model';
import { ChartDisplayElementModel } from '../../../Common/Reports/models/chart-display-element.model';
import { BriefingDeliveryMethodEnum } from '../enums/briefing-delivery-method.enum';
import { ReportSeriesModel } from '@Common/Reports/models/report-series.model';
import { BlockDisplayTypeEnum } from '../../../Common/PageBuilder/enums/block-display-type.enum';
import { BriefingTitleDisplayElementModel } from './briefing-title-display-element.model';
import { BriefingCoverageCuratorDisplayElementApiModel } from '../../../api/briefings/model/briefing-coverage-curator-display-element-api.model';
import { CuratorDisplayElement } from '../../../Common/PageBuilder/models/curator-display-element.model';
import { BriefingSearchApi } from '../../../api/briefings/model/briefing-search-api';
import { CuratorBlock } from '../../../Common/PageBuilder/models/curator-block.model';
import { OnlineBriefingTemplateConfigModel } from './online-briefing-option.model';
import { BriefingCuratedMentionDetailsApi } from '@api/briefings/model/briefing-curated-mention-Details-api';
import { AiAnalysisTypes } from '../../../Common/Mentions/enums/ai-analysis-types.enum';
import { ReportBlockTypeEnum } from '@Common/Reports/enums/report-block-type.enum';
import { BaseModel } from '../../../Common/Basic/models/base.model';
import { OnlineBriefingInviteStyleModel } from '@api/briefings/model/briefing-invite-style.model';
import { MentionModel } from '../../../api/mentions/model/mention.model';
import { briefingAnnotatableBlockTypes } from '@Common/Reports/models/new-data-processing-workflow-block-types.model';
import { LayoutBlockType } from '../../../Common/PageBuilder/models/layout-block-type.model';
import { CuratorBlockType } from '../../../Common/PageBuilder/models/curator-block-type.model';
import { PrecisionClipApi } from '../../../api/briefings/model/precision-clip.api.model';


export class BriefingModel extends BaseModel<BriefingModel, BriefingApiModel> implements AuditableModel {

    public static defaultBriefingStyles = defaultBriefingStyles;

    id: number;
    name: string;
    reservedGuid: string;
    subject: string;
    previewText: string;
    recipientList: string[];
    mailingListIds: number[];
    feeds: BriefingFeedModel[];
    blocks: BlockModel[];
    sendAt: BriefingSendAtModel;
    status: BriefingStatusEnum;
    type: BriefingTypeEnum;
    fromName: string;
    replyTo: string;
    generalStyles: BriefingGeneralStylesModel;
    organizeBy: BriefingOrganizeByEnum;
    searchCriteriaId: number;

    createdByUserId: number;
    createdDate: number;

    modifiedByUserId: number;
    modifiedDate: number;

    selectedDeliveryOption: DeliveryOptionModel;
    includeEmptyMentionSections: boolean;
    includeInsightsLink: boolean;
    sendRecurringBriefingWhenMentionsEmpty: boolean;
    enableMobileFormatting: boolean;
    enableDuplicateMentions: boolean;
    sentDate: string;
    groupId: number;
    isFavorite: boolean = false;
    alertType: AlertTypeEnum;
    hasBeenSent: boolean;
    deliveryMethod: BriefingDeliveryMethodEnum;
    globalSourceSingleSeries: ReportSeriesModel;
    globalSourceMultiSeries: ReportSeriesModel[];
    inviteMessage?: string;
    clickTracking: boolean = true;
    openTracking: boolean = true;
    canvasPreview: OnlineBriefingTemplateConfigModel | null = null;
    onlineBriefingInviteStyle: OnlineBriefingInviteStyleModel | null = null;

    get isPreviewMode(): boolean {
        return !!this.canvasPreview;
    }

    // F/E use only
    digests: number[] = [];

    cachedMentionsWithInsight: BriefingCuratedMentionDetailsApi[] = [];

    private simpleCompareFields = [
        'id',
        'name',
        'subject',
        'previewText',
        'status',
        'type',
        'fromName',
        'replyTo',
        'organizeBy',
        'sortBy',
        'searchCriteriaId',
        'includeEmptyMentionSections',
        'includeInsightsLink',
        'sendRecurringBriefingWhenMentionsEmpty',
        'enableMobileFormatting',
        'enableDuplicateMentions',
        'inviteMessage',
        'clickTracking',
        'openTracking'
    ];

    /**
     * Determines whether or not the time zone
     * to send the briefing at is valid
    */
    get hasValidSendAtTimezone(): boolean {
        const hasSendAt: boolean = this.sendAt instanceof BriefingSendAtModel;
        const hasValidTimezone: boolean = hasSendAt && this.sendAt.hasValidTimezone;

        return hasValidTimezone;
    }

    get isSaved(): boolean {
        return !!this.id;
    }


    constructor(apiModel?: BriefingApiModel) {
        super();
        if (apiModel) {
            this.constructFromApiModel(apiModel);
        } else {
            this.constructDefault();
        }
        this.setGeneralStyles(this.generalStyles);
        this.setSelectedDeliveryOptions();
    }

    constructFromApiModel(apiModel: BriefingApiModel) {
        this.cachedMentionsWithInsight = [];
        this.id = apiModel.briefingId;
        this.name = apiModel.briefingName;
        this.reservedGuid = apiModel.reservedGuid;
        this.subject = apiModel.briefingSubject;
        this.previewText = apiModel.previewText?.trim() ? apiModel.previewText.trim() : null;
        this.recipientList = apiModel.recipientEmail;
        this.mailingListIds = apiModel.mailingListIds || [];
        this.feeds = apiModel.feeds?.map(x => new BriefingFeedModel(x)) || [];
        this.status = briefingStatusMapFromApi.get(apiModel.status);
        this.sentDate = apiModel.sentDate;
        this.includeInsightsLink = apiModel.includeInsightsLink;
        this.alertType = apiModel.alertType ? apiModel.alertType : AlertTypeEnum.RECENT;
        this.deliveryMethod = apiModel.deliveryMethod ? apiModel.deliveryMethod : BriefingDeliveryMethodEnum.EMAIL;
        this.blocks = this.mapBlocksFromApi(apiModel.blocks);
        this.sendAt = new BriefingSendAtModel(apiModel.sendAt);
        this.type = apiModel.type || BriefingTypeEnum.BRIEFING;
        this.fromName = apiModel.fromName;
        this.replyTo = apiModel.replyTo ? apiModel.replyTo.trim() : '';
        this.generalStyles = new BriefingGeneralStylesModel(JSON.parse(apiModel.generalStyles));
        this.organizeBy = briefingOrganizeByMapFromApi.get(apiModel.organizeBy) || BriefingOrganizeByEnum.MANUAL;
        this.searchCriteriaId = apiModel.searchCriteriaId;
        this.createdByUserId = apiModel.createdByUserId;
        this.createdDate = apiModel.createdDate ? TimeHelper.convertTo13DigitTimestamp(apiModel.createdDate) : null;
        this.selectedDeliveryOption = new DeliveryOptionModel();
        if (apiModel.modifiedByUserId) {
            this.modifiedByUserId = apiModel.modifiedByUserId;
            this.modifiedDate = apiModel.modifiedDate ? TimeHelper.convertTo13DigitTimestamp(apiModel.modifiedDate) : null;
        }
        this.includeEmptyMentionSections = apiModel.includeEmptyMentionSections;
        this.sendRecurringBriefingWhenMentionsEmpty = apiModel.sendRecurringBriefingWhenMentionsEmpty;
        this.enableMobileFormatting = apiModel.enableMobileFormatting;
        this.enableDuplicateMentions = apiModel.enableDuplicateMentions;
        this.groupId = apiModel.displayGroupId;
        this.isFavorite = apiModel.isFavorited;
        this.hasBeenSent = apiModel.hasBeenSent;
        this.inviteMessage = apiModel.inviteMessage;
        this.clickTracking = apiModel.enableClickTracking ?? true;
        this.openTracking = apiModel.enableOpenTracking ?? true;
        this.digests = apiModel.digests;
        this.selectedDeliveryOption.digest = !!this.digests?.length;
        this.canvasPreview = apiModel.canvasPreview ? new OnlineBriefingTemplateConfigModel(apiModel.canvasPreview) : null;
        this.onlineBriefingInviteStyle = apiModel.onlineBriefingInviteStyle ?? null;
    }

    constructDefault() {
        this.id = null;
        this.name = null;
        this.subject = null;
        this.previewText = null;
        this.recipientList = [];
        this.mailingListIds = [];
        this.feeds = [];
        this.blocks = [];
        this.sendAt = new BriefingSendAtModel();
        this.fromName = null;
        this.replyTo = null;
        this.status = BriefingStatusEnum.DRAFT;
        this.type = BriefingTypeEnum.BRIEFING;
        this.generalStyles = new BriefingGeneralStylesModel();
        this.organizeBy = BriefingOrganizeByEnum.MANUAL;
        this.searchCriteriaId = null;
        this.createdByUserId = null;
        this.createdDate = null;
        this.selectedDeliveryOption = new DeliveryOptionModel();
        this.includeEmptyMentionSections = false;
        this.includeInsightsLink = false;
        this.sendRecurringBriefingWhenMentionsEmpty = true;
        this.enableMobileFormatting = false;
        this.enableDuplicateMentions = false;
        this.alertType = AlertTypeEnum.RECENT;
        this.deliveryMethod = BriefingDeliveryMethodEnum.EMAIL;
        this.onlineBriefingInviteStyle = null;
    }



    equals(other: BriefingModel): boolean {
        if (other === null || other === undefined) {
            return false;
        }
        // Compare simple fields
        for (let i = 0; i < this.simpleCompareFields.length; i++) {
            const field = this.simpleCompareFields[i];
            if ((this as any)[field] !== (other as any)[field]) {
                return false;
            }
        }
        // Compare recipient list
        if (this.recipientList?.length !== other.recipientList?.length ||
            difference(this.recipientList, other.recipientList).length !== 0) {
            return false;
        }
        // Compare mailing lists
        if (this.mailingListIds?.length !== other.mailingListIds?.length ||
            difference(this.mailingListIds, other.mailingListIds).length !== 0) {
            return false;
        }
        // Compare sendAt
        if (!this.sendAt.equals(other.sendAt)) {
            return false;
        }
        // Compare general styles
        if (!this.generalStyles.equals(other.generalStyles)) {
            return false;
        }
        // Compare blocks
        if (this.blocks.length !== other.blocks.length) {
            return false;
        }
        // Compare blocks
        for (let i = 0; i < this.blocks.length; i++) {
            const thisBlock = this.blocks[i];
            const otherBlock = other.blocks[i];

            if (!!thisBlock.id !== !!otherBlock.id) {
                return false;
            }

            if (!thisBlock.type || !otherBlock.type || thisBlock.type.key !== otherBlock.type.key) {
                return false;
            }

            if (!thisBlock.displayElement.isEqual(otherBlock.displayElement)) {
                // TODO: verify this works once blocks call .setBlocks on confirm
                return false;
            }

            if (thisBlock.isLayoutBlockType()) {
                const thisLayoutBlock = thisBlock as LayoutBlock;
                const otherLayoutBlock = otherBlock as LayoutBlock;

                if (thisLayoutBlock.blocks?.length !== otherLayoutBlock.blocks?.length) {
                    return false;
                }

                for (let col = 0; col < thisLayoutBlock.blocks.length; col++) {
                    const thisCol = thisLayoutBlock.blocks[col];
                    const otherCol = otherLayoutBlock.blocks[col];
                    if (thisCol.length !== otherCol.length) {
                        return false;
                    }
                    for (let pos = 0; pos < thisCol.length; pos++) {
                        const a = thisCol[pos];
                        const b = otherCol[pos];
                        if (a.id !== b.id) {
                            return false;
                        }
                        if (!a.type || !b.type || a.type.key !== b.type.key) {
                            return false;
                        }
                        if (!a.displayElement.isEqual(b.displayElement)) {
                            return false;
                        }
                    }
                }
            }

            if (thisBlock instanceof CuratorBlock) {
                const thisCuratorBlock = thisBlock as CuratorBlock;
                const otherCuratorBlock = otherBlock as CuratorBlock;

                if (thisCuratorBlock.blocks?.length !== otherCuratorBlock.blocks?.length) {
                    return false;
                }

                for (let pos = 0; pos < thisCuratorBlock.blocks.length; pos++) {
                    const a = thisCuratorBlock.blocks[pos];
                    const b = otherCuratorBlock.blocks[pos];
                    if (a.id !== b.id) {
                        return false;
                    }
                    if (!a.type || !b.type || a.type.key !== b.type.key) {
                        return false;
                    }
                    if (!a.displayElement.isEqual(b.displayElement)) {
                        return false;
                    }
                }
            }
        }

        // Compare feeds
        if (this.feeds?.length !== other.feeds?.length) {
            return false;
        } else {
            let isFeedsEqual = true;
            this.feeds.forEach((x, index) => {
                if (x.id !== other.feeds[index].id || x.clearOnPublish !== other.feeds[index].clearOnPublish) {
                    isFeedsEqual = false;
                }
            });
            if (!isFeedsEqual) {
                return false;
            }
        }

        // Compare digest lists
        if (this.digests?.length !== other.digests?.length ||
            difference(this.digests, other.digests).length !== 0) {
            return false;
        }

        // Compare selectedDeliveryOption
        if (this.selectedDeliveryOption.email !== other.selectedDeliveryOption.email) {
            return false;
        }
        if (this.selectedDeliveryOption.rssFeed !== other.selectedDeliveryOption.rssFeed) {
            return false;
        }

        if (JSON.stringify(this.cachedMentionsWithInsight) !== JSON.stringify(other.cachedMentionsWithInsight)) {
            return false;
        }

        const canvasPreviewEqual = this.canvasPreview === other.canvasPreview
            || (!!this.canvasPreview && !!other.canvasPreview && this.canvasPreview.equals(other.canvasPreview));
        if (!canvasPreviewEqual) {
            return false;
        }

        const emailStyleEqual = this.onlineBriefingInviteStyle === other.onlineBriefingInviteStyle
            || JSON.stringify(this.onlineBriefingInviteStyle) === JSON.stringify(other.onlineBriefingInviteStyle);
        if (!emailStyleEqual) {
            return false;
        }

        return true;
    }


    toApiModel(forClone: boolean = false): BriefingApiModel {
        let status = briefingStatusMapToApi.get(this.status);
        if (!this.sendAt.recurring
            && (status === BriefingStatusApiEnum.ACTIVE || status === BriefingStatusApiEnum.PAUSED)
            && this.type === BriefingTypeEnum.BRIEFING
        ) {
            status = BriefingStatusApiEnum.DRAFT;
        }

        const briefingApiModel: BriefingApiModel = {
            briefingId: this.id,
            briefingName: this.name,
            briefingSubject: this.subject,
            previewText: this.previewText?.trim() ? this.previewText.trim() : null,
            mailingListIds: this.mailingListIds.slice(),
            feeds: this.feeds.map(x => {
                return {
                    id: x.id,
                    clearOnPublish: x.clearOnPublish
                };
            }),
            recipientEmail: this.recipientList ? this.recipientList.slice() : null,
            blocks: this.mapBlocksToApi(this.blocks, 640, forClone),
            sendAt: this.sendAt ? this.sendAt.toBriefingSendAtApiModel() : null,
            status,
            type: this.type,
            generalStyles: JSON.stringify(this.generalStyles.toApi()),
            replyTo: this.replyTo ? this.replyTo.trim() : '',
            fromName: this.fromName,
            organizeBy: briefingOrganizeByMapToApi.get(this.organizeBy),
            searchCriteriaId: this.searchCriteriaId,
            createdByUserId: this.createdByUserId,
            createdDate: this.createdDate,
            modifiedByUserId: this.modifiedByUserId,
            modifiedDate: this.modifiedDate,
            includeEmptyMentionSections: this.includeEmptyMentionSections,
            includeInsightsLink: this.includeInsightsLink,
            sendRecurringBriefingWhenMentionsEmpty: this.sendRecurringBriefingWhenMentionsEmpty,
            enableMobileFormatting: this.enableMobileFormatting,
            enableDuplicateMentions: this.enableDuplicateMentions,
            enableClickTracking: this.clickTracking,
            enableOpenTracking: this.openTracking,
            displayGroupId: this.groupId,
            isFavorited: this.isFavorite,
            alertType: this.alertType,
            deliveryMethod: this.deliveryMethod ? this.deliveryMethod : BriefingDeliveryMethodEnum.EMAIL,
            inviteMessage: this.inviteMessage,
            digests: this.digests?.slice(),
            canvasPreview: this.canvasPreview ? this.canvasPreview.toApiString() : undefined,
        };

        if (this.deliveryMethod === BriefingDeliveryMethodEnum.ONLINE) {
            briefingApiModel.canvasGlobalSettings = {
                accentColour: this.generalStyles.accentColor,
                includeEmptySections: this.includeEmptyMentionSections
            };
            briefingApiModel.onlineBriefingInviteStyle = this.onlineBriefingInviteStyle;
        }

        if (!briefingApiModel.briefingId) {
            delete briefingApiModel.briefingId;
        }

        return briefingApiModel;
    }

    /**
     * Returns a copy of this model reset as if it were not yet saved
     */
    clone(): BriefingModel {
        const clone = new BriefingModel(this.toApiModel(true));
        delete clone.id;
        clone.status = BriefingStatusEnum.DRAFT;
        clone.createdByUserId = null;
        clone.createdDate = null;
        clone.modifiedByUserId = null;
        clone.modifiedDate = null;
        clone.name = null;

        return clone;
    }

    /**
     * Converts BriefingBlockApiModel[] to BlockModel[]
     */
    protected mapBlocksFromApi(apiBlocks: BriefingBlockApiModel[] = [], columnWidth: number = 640): BlockModel[] {
        const blocks: BlockModel[] = [];

        apiBlocks.forEach(
            apiBlock => {

                let blockTypeEnum = briefingBlockTypeEnumFromApi.get(apiBlock.type);
                if (blockTypeEnum === BriefingBlockTypeEnum.LAYOUT) {
                    const columnNumber = (apiBlock as any).columns.length;
                    blockTypeEnum = columnNumberToBriefingBlockTypeMap.get(columnNumber);
                }

                const blockType = briefingBlockTypeEnumToBlockTypeMap.get(blockTypeEnum);

                if (!blockType && apiBlock.type !== BriefingBlockTypeApiEnum.LAYOUT) {
                    return;
                }
                let block;

                switch (blockTypeEnum) {
                    case BriefingBlockTypeEnum.TITLE:
                        const titleApiData: BriefingTitleDisplayElementApiModel = apiBlock as BriefingTitleDisplayElementApiModel;
                        let titleApiBlockStyles = apiBlock.styles;

                        if (titleApiBlockStyles !== undefined) {
                            titleApiBlockStyles = JSON.parse(titleApiBlockStyles);
                            const styleState = this.getDefaultStyleState(titleApiBlockStyles);
                            this.setDefaultStyles(BriefingModel.defaultBriefingStyles[styleState].title, titleApiBlockStyles);
                        }

                        block = new BlockModel(
                            apiBlock.id,
                            blockType,
                            new BriefingTitleDisplayElementModel(
                                titleApiData.title,
                                titleApiBlockStyles,
                                titleApiData.titleSettings,
                                titleApiData.automaticallyGenerated
                            )
                        );
                        break;

                    case BriefingBlockTypeEnum.TEXT:
                        const textApiData: BriefingTextDisplayElementApiModel = apiBlock as BriefingTextDisplayElementApiModel;
                        let textApiBlockStyles = apiBlock.styles;

                        if (textApiBlockStyles !== undefined) {
                            textApiBlockStyles = JSON.parse(textApiBlockStyles);
                            const styleState = this.getDefaultStyleState(textApiBlockStyles);
                            this.setDefaultStyles(BriefingModel.defaultBriefingStyles[styleState].text, textApiBlockStyles);
                        }

                        block = new BlockModel(
                            apiBlock.id,
                            blockType,
                            new BriefingTextDisplayElementModel(textApiData.content, textApiBlockStyles)
                        );

                        (block.displayElement as BriefingTextDisplayElementModel).enableAIRefinement = true;
                        block.displayElement.htmlEdit = textApiBlockStyles['htmlEdit'];
                        break;

                    case BriefingBlockTypeEnum.IMAGE:
                        const imageApiData: BriefingImageDisplayElementApiModel = apiBlock as BriefingImageDisplayElementApiModel;
                        block = new BlockModel(
                            apiBlock.id,
                            blockType,
                            new BriefingImageDisplayElementModel(imageApiData)
                        );
                        if ((block.displayElement as BriefingImageDisplayElementModel).images?.length) {
                            (block.displayElement as BriefingImageDisplayElementModel).images =
                                (block.displayElement as BriefingImageDisplayElementModel).images.sort((a, b) => a.location - b.location);
                        } else {
                            (block.displayElement as BriefingImageDisplayElementModel).images = [];
                        }
                        break;

                    case BriefingBlockTypeEnum.DATE:
                        const dateApiBlock = apiBlock as BriefingDateDisplayElementApiModel;
                        let dateApiBlockStyles = apiBlock.styles;

                        if (dateApiBlockStyles !== undefined) {
                            dateApiBlockStyles = JSON.parse(dateApiBlockStyles);
                            const styleState = this.getDefaultStyleState(dateApiBlockStyles);
                            this.setDefaultStyles(BriefingModel.defaultBriefingStyles[styleState].date, dateApiBlockStyles);
                        }

                        // if the date doesn't exist, use the default (current date)
                        let timestamp;
                        if (dateApiBlock.timestamp) {
                            // The api uses UTC time, so we must convert it to the local time to be used properly.
                            timestamp = +new Date(dateApiBlock.timestamp + (new Date().getTimezoneOffset() * 1000 * 60));
                        }

                        if (!dateApiBlock.timestamp && this.status === BriefingStatusEnum.SENT && this.sentDate) {
                            timestamp = +new Date(this.sentDate);
                        }

                        const dateDisplayElementFromApi = new DateDisplayElementModel(
                            timestamp,
                            dateApiBlock.format,
                            dateApiBlockStyles
                        );
                        if (dateApiBlock.dateQuery) {
                            const aq = dateApiBlock.dateQuery;
                            const restoredDateQuery: DateQueryModel = {
                                type: aq.dateType,
                                relativeStartOffsetH: aq.relativeStartOffsetH,
                                relativeEndOffsetH: aq.relativeEndOffsetH,
                                relativeTimezoneDateType: aq.relativeTimezoneDateType,
                                timezone: aq.timeZone
                            } as DateQueryModel;
                            if (aq.dateRange) {
                                restoredDateQuery.absoluteRange = {
                                    start: new Date(aq.dateRange.start),
                                    end: new Date(aq.dateRange.end)
                                };
                            }
                            dateDisplayElementFromApi.dateQuery = restoredDateQuery;
                        }
                        if (dateApiBlock.dateRangeType) {
                            dateDisplayElementFromApi.dateRangeType = dateApiBlock.dateRangeType;
                        }
                        block = new BlockModel(
                            apiBlock.id,
                            blockType,
                            dateDisplayElementFromApi
                        );
                        break;

                    case BriefingBlockTypeEnum.DIVIDER:
                        const dividerApiData = apiBlock as BriefingAutomaticMentionListDisplayElementApiModel;
                        block = new BlockModel(
                            null,
                            blockType,
                            new DividerDisplayElementModel(dividerApiData.styles)
                        );
                        break;

                    case BriefingBlockTypeEnum.AUTOMATIC_MENTION_LIST:
                        const automatedApiBlock = apiBlock as BriefingAutomaticMentionListDisplayElementApiModel;
                        let automatedApiBlockStyles = apiBlock.styles;

                        if (automatedApiBlockStyles !== undefined) {
                            automatedApiBlockStyles = JSON.parse(automatedApiBlockStyles);
                            const styleState = this.getDefaultStyleState(automatedApiBlockStyles);
                            this.setDefaultStyles(BriefingModel.defaultBriefingStyles[styleState].mention, automatedApiBlockStyles);
                        }

                        let sourceType: MonitoringSeriesTypeEnum = MonitoringSeriesTypeEnum.topic;


                        sourceType = mentionSourceApiTypesEnumToMonitoringSeriesTypeEnum.get(automatedApiBlock.sourceType);


                        const dynamicMentionListDisplayElementModel = new DynamicMentionListDisplayElementModel(
                            automatedApiBlock.title,
                            sourceType,
                            automatedApiBlock.searchCriteriaId,
                            automatedApiBlock.maxNumberOfMentionsInEmail ? automatedApiBlock.maxNumberOfMentionsInEmail : 10,
                            automatedApiBlock.filterSearchCriteriaId,
                            undefined,
                            automatedApiBlockStyles,
                            automatedApiBlock.blockReferenceId,
                            automatedApiBlock.mentionPreviewCount,
                            automatedApiBlock.automaticallyGenerated
                        );


                        if (automatedApiBlock.briefingAutoGenerateInsightRequest) {
                            dynamicMentionListDisplayElementModel.additionalSettings.autoGenInsight = automatedApiBlock.briefingAutoGenerateInsightRequest;
                        }


                        if (automatedApiBlock.generatePrecisionClips) {
                            dynamicMentionListDisplayElementModel.additionalSettings.precisionClip = {};
                            /* eslint-disable max-len */
                            dynamicMentionListDisplayElementModel.additionalSettings.precisionClip.savedMentionKeywords = automatedApiBlock.generatePrecisionClips.isSavedMentionKeywords;
                            dynamicMentionListDisplayElementModel.additionalSettings.precisionClip.manualKeywords = automatedApiBlock.generatePrecisionClips.keywords;
                            dynamicMentionListDisplayElementModel.additionalSettings.precisionClip.fallbackKeywords = automatedApiBlock.generatePrecisionClips.fallbackKeywords;
                            dynamicMentionListDisplayElementModel.additionalSettings.precisionClip.generateInsights = automatedApiBlock.generatePrecisionClips.isGenerateInsights;
                            dynamicMentionListDisplayElementModel.additionalSettings.precisionClip.extendedStart = automatedApiBlock.generatePrecisionClips.extendedStart;
                            dynamicMentionListDisplayElementModel.additionalSettings.precisionClip.extendedEnd = automatedApiBlock.generatePrecisionClips.extendedEnd;
                            /* eslint-enable max-len */
                        }

                        dynamicMentionListDisplayElementModel.includeInsightsLink = this.includeInsightsLink;

                        block = new BlockModel(
                            apiBlock.id,
                            blockType,
                            dynamicMentionListDisplayElementModel
                        );

                        break;

                    case BriefingBlockTypeEnum.CURATED_MENTION_LIST:
                        const curatedApiBlock = apiBlock as BriefingCuratedMentionListDisplayElementApiModel;
                        let curatedApiBlockStyles = apiBlock.styles;

                        curatedApiBlock.mentions?.forEach(mention => {
                            mention.blockReferenceId = curatedApiBlock.blockReferenceId;
                            this.cachedMentionsWithInsight.push(mention);
                        });

                        if (curatedApiBlockStyles !== undefined) {
                            curatedApiBlockStyles = JSON.parse(curatedApiBlockStyles);
                            const styleState = this.getDefaultStyleState(curatedApiBlockStyles);
                            this.setDefaultStyles(BriefingModel.defaultBriefingStyles[styleState].mention, curatedApiBlockStyles);
                        }

                        // Preserve insight data for Previewing and Copying Briefings.
                        const curatedMentionStubs = curatedApiBlock.mentions?.map(mention => ({
                            mercuryId: mention.mentionId,
                            insights: mention.insight ? [mention.insight] : []
                        } as MentionModel)) || [];

                        const curatedMentionListDisplayElementModel = new CuratedMentionListDisplayElementModel(
                            curatedApiBlock.title,
                            curatedApiBlock.mentionIds,
                            curatedMentionStubs,
                            curatedApiBlock.searchCriteriaId,
                            undefined,
                            curatedApiBlockStyles,
                            curatedApiBlock.blockReferenceId,
                            curatedApiBlock.mentionPreviewCount
                        );

                        curatedMentionListDisplayElementModel.includeInsightsLink = this.includeInsightsLink;
                        block = new BlockModel(
                            apiBlock.id,
                            blockType,
                            curatedMentionListDisplayElementModel
                        );
                        break;

                    case BriefingBlockTypeEnum.TABLE_OF_CONTENT:
                        const tableOfContentApiBlock = apiBlock as BriefingTableOfContentDispalyElementApiModel;
                        let tableOfContentApiBlockStyles = apiBlock.styles;

                        if (tableOfContentApiBlockStyles !== undefined) {
                            tableOfContentApiBlockStyles = JSON.parse(tableOfContentApiBlockStyles);
                            const styleState = this.getDefaultStyleState(tableOfContentApiBlockStyles);
                            this.setDefaultStyles(BriefingModel.defaultBriefingStyles[styleState].tableOfContent, tableOfContentApiBlockStyles);
                        }

                        block = new BlockModel(
                            apiBlock.id,
                            blockType,
                            new TableOfContentDisplayElementModel(
                                tableOfContentApiBlockStyles,
                                JSON.parse(tableOfContentApiBlock.settings)
                            )
                        );
                        break;

                    case BriefingBlockTypeEnum.ANALYSIS:
                        const analysisApiBlock = apiBlock as BriefingAnalysisDisplayElementApiModel;
                        let analysisApiBlockStyles = apiBlock.styles;

                        if (analysisApiBlockStyles !== undefined) {
                            analysisApiBlockStyles = JSON.parse(analysisApiBlockStyles);
                            const styleState = this.getDefaultStyleState(analysisApiBlockStyles);
                            this.setDefaultStyles(BriefingModel.defaultBriefingStyles[styleState].analysis, analysisApiBlockStyles);
                        }

                        const analysisDisplayElementModel = new AnalysisDisplayElementModel(
                            analysisApiBlock.value,
                            analysisApiBlockStyles,
                            analysisApiBlock
                        );
                        analysisDisplayElementModel.enableAIRefinement = true;

                        block = new BlockModel(
                            apiBlock.id,
                            blockType,
                            analysisDisplayElementModel
                        );
                        break;

                    case BriefingBlockTypeEnum.LINK:
                        const linkApiData: BriefingLinkDisplayElementApiModel = apiBlock as BriefingLinkDisplayElementApiModel;
                        block = new BlockModel(
                            null,
                            blockType,
                            new LinkDisplayElementModel(linkApiData.styles, linkApiData.links)
                        );
                        break;

                    case BriefingBlockTypeEnum.ONE_COLUMN_LAYOUT:
                    case BriefingBlockTypeEnum.TWO_COLUMN_LAYOUT:
                    case BriefingBlockTypeEnum.THREE_COLUMN_LAYOUT:
                        const layoutDisplayElement = new LayoutDisplayElement(apiBlock.styles);
                        const numColumnsFromApi = apiBlock.columns.length;
                        let paddingWidth = (layoutDisplayElement.styles.columnSpacing || 0) * Math.max(0, numColumnsFromApi - 1);
                        if (layoutDisplayElement.styles.padding?.paddingOption) {
                            paddingWidth = paddingWidth + (layoutDisplayElement.styles.padding.leftPadding || 0)
                                + (layoutDisplayElement.styles.padding.rightPadding || 0);
                        } else if (layoutDisplayElement.styles.padding?.paddingOption === false) {
                            paddingWidth += (layoutDisplayElement.styles.padding.paddingAll * 2 || 0);
                        }
                        block = new LayoutBlock(
                            null,
                            blockType as LayoutBlockType,
                            layoutDisplayElement,
                            apiBlock.columns.map((column, index) => {
                                return this.mapBlocksFromApi(
                                    column.blocks,
                                    (columnWidth - paddingWidth) * parseFloat(layoutDisplayElement.styles.width?.[index]) / 100
                                );
                            })
                        );
                        break;

                    case BriefingBlockTypeEnum.CHART:
                        const chartApiBlock = apiBlock as BriefingChartDisplayElementApiModel;
                        const chartApiBlockStyles = apiBlock.styles;

                        if (chartApiBlockStyles !== undefined) {
                            const chartApiBlockStylesModel = JSON.parse(chartApiBlockStyles);
                            // need to add this check for all exisintg briefings, since we put a 12px border by default before (not in styles)
                            if (this.deliveryMethod === BriefingDeliveryMethodEnum.ONLINE) {
                                if (!chartApiBlockStylesModel.cornerRadius) {
                                    chartApiBlockStylesModel.cornerRadius = {
                                        cornerRadiusAll: 12,
                                        cornerRadiusOption:  false,
                                        topLeftCornerRadius: 0,
                                        topRightCornerRadius: 0,
                                        bottomLeftCornerRadius: 0,
                                        bottomRightCornerRadius: 0
                                    };
                                    apiBlock.styles = JSON.stringify(chartApiBlockStylesModel);
                                }
                            }
                            const styleState = this.getDefaultStyleState(chartApiBlockStylesModel);
                            this.setDefaultStyles(BriefingModel.defaultBriefingStyles[styleState].image, chartApiBlockStylesModel);
                        }

                        const chartDisplayElement = new BriefingChartDisplayElementModel(
                            chartApiBlock
                        );
                        let chartPaddingWidth = 0;
                        if (chartDisplayElement.styles.padding?.paddingOption) {
                            chartPaddingWidth = chartPaddingWidth + (chartDisplayElement.styles.padding.leftPadding || 0)
                                + (chartDisplayElement.styles.padding.rightPadding || 0);
                        } else if (chartDisplayElement.styles.padding?.paddingOption === false) {
                            chartPaddingWidth += (chartDisplayElement.styles.padding.paddingAll * 2 || 0);
                        }
                        if (chartDisplayElement.styles.doBorder) {
                            chartPaddingWidth += (chartDisplayElement.styles.borderWidth || 0) * 2;
                        }
                        // eslint-disable-next-line max-len
                        chartDisplayElement.chart.widthPercent = Math.min(100, Math.round(chartDisplayElement.chart.widthPx / (columnWidth - chartPaddingWidth) * 100));
                        if (chartApiBlock['mentionSearches']?.length) {
                            chartDisplayElement.mentionSearches = chartApiBlock['mentionSearches'];
                        }

                        block = new BlockModel(
                            apiBlock.id,
                            blockType,
                            chartDisplayElement
                        );
                        block.canAnnotate = briefingAnnotatableBlockTypes.includes(chartDisplayElement.chartBlock?.type?.key as ReportBlockTypeEnum);

                        break;

                    case BriefingBlockTypeEnum.COVERAGE_CURATOR:
                        const curatorApiBlock = apiBlock as BriefingCoverageCuratorDisplayElementApiModel;
                        let curatorApiBlockStyles = apiBlock.styles;

                        if (curatorApiBlockStyles !== undefined) {
                            curatorApiBlockStyles = JSON.parse(curatorApiBlockStyles);
                            const styleState = this.getDefaultStyleState(curatorApiBlockStyles, );
                            this.setDefaultStyles(BriefingModel.defaultBriefingStyles[styleState].coverageCurator, curatorApiBlockStyles);
                        }

                        const curatorDisplayElementModel = new CuratorDisplayElement(
                            curatorApiBlockStyles,
                            curatorApiBlock
                        );

                        const innerBlocks = this.mapBlocksFromApi(curatorApiBlock.blocks);
                        const originalBlocks = curatorApiBlock.originalBlocks ? this.mapBlocksFromApi(JSON.parse(curatorApiBlock.originalBlocks)) : [];
                        [...innerBlocks, ...originalBlocks].forEach(x => x.displayElement.canAutomaticallyGenerated = true);

                        block = new CuratorBlock(
                            apiBlock.id,
                            blockType as CuratorBlockType,
                            curatorDisplayElementModel,
                            innerBlocks || [],
                            originalBlocks
                        );
                        break;
                    default:
                        // Unknown block type, do nothing
                        break;
                }

                if (apiBlock.styles) {
                    // backend sometimes passes "null"
                    const styles = JSON.parse(apiBlock.styles);
                    if (styles) {
                        // @ TODO - NEP-3392 hack should add isBoundToGlobalStyles to
                        block.displayElement.isBoundToGlobalStyles = styles.isBoundToGlobalStyles === true || styles.isBoundToGlobalStyles === 'true';
                    } else {
                        block.displayElement.isBoundToGlobalStyles = true;
                    }
                } else {
                    block.displayElement.isBoundToGlobalStyles = true;
                }


                // HACK @TODO remove if statement in NEP-3409
                if (blockType?.key === BriefingBlockTypeApiEnum.AUTOMATIC_MENTION_LIST) {
                    block.displayElement.isBoundToGlobalStyles = true;
                }

                if (this.deliveryMethod === BriefingDeliveryMethodEnum.ONLINE) {
                    block.displayElement.displayType = BlockDisplayTypeEnum.ONLINE;
                }
                blocks.push(block);
            }
        );

        return blocks;
    }

    /**
     * Converts BlockModel[] to BriefingBlockApiModel[]
     */
    protected mapBlocksToApi(blocks: BlockModel[], columnWidth: number = 640, forClone: boolean = false): BriefingBlockApiModel[] {
        const apiBlocks: BriefingBlockApiModel[] = [];

        blocks.forEach(
            block => {
                if (!block.type || !block.type.key) {

                    return;
                }

                // hack @TODO NEP-3392
                let styles;
                // endhack

                switch (block.type.key) {
                    case BriefingBlockTypeEnum.TITLE:
                        const titleDisplayElement = block.displayElement as BriefingTitleDisplayElementModel;

                        // hack @TODO NEP-3392
                        styles = titleDisplayElement.styles.toBlockStyle();
                        styles.isBoundToGlobalStyles = titleDisplayElement.isBoundToGlobalStyles;
                        // endhack

                        apiBlocks.push({
                            id: block.id,
                            type: briefingBlockTypeEnumToApi.get(block.type.key as BriefingBlockTypeEnum),
                            styles: JSON.stringify(styles),
                            title: titleDisplayElement.text,
                            automaticallyGenerated: titleDisplayElement.automaticallyGenerated,
                            titleSettings: JSON.stringify({ headingLevel: titleDisplayElement.headingLevel }),
                            customStyleId: styles && Number.isInteger(styles.styleState) ? styles.styleState : null
                        } as BriefingTitleDisplayElementApiModel);

                        break;

                    case BriefingBlockTypeEnum.TEXT:
                        const textDisplayElement = block.displayElement as TextDisplayElementModel;

                        // hack @TODO NEP-3392
                        styles = textDisplayElement.styles.toBlockStyle();
                        styles.isBoundToGlobalStyles = textDisplayElement.isBoundToGlobalStyles;
                        styles.htmlEdit = textDisplayElement.htmlEdit;
                        // endhack

                        apiBlocks.push({
                            id: block.id,
                            type: briefingBlockTypeEnumToApi.get(block.type.key as BriefingBlockTypeEnum),
                            styles: JSON.stringify(styles),
                            content: textDisplayElement.text,
                            customStyleId: styles && Number.isInteger(styles.styleState) ? styles.styleState : null
                        } as BriefingTextDisplayElementApiModel);

                        break;

                    case BriefingBlockTypeEnum.IMAGE:
                        const imageDisplayElement = block.displayElement as BriefingImageDisplayElementModel;

                        // fail safe (for old briefings that didn't have location set)
                        if (!imageDisplayElement.images?.[0]?.hasOwnProperty('location')) {
                            imageDisplayElement.images?.forEach((file, index) => file.location = index);
                        }

                        const apiBlock = imageDisplayElement.toApi(Math.min(imageDisplayElement.images?.[0]?.width, columnWidth));

                        // hack @TODO NEP-3392
                        styles = imageDisplayElement.styles.toBlockStyle();
                        styles.isBoundToGlobalStyles = imageDisplayElement.isBoundToGlobalStyles;
                        styles.originalWidth = imageDisplayElement.images?.[0]?.width;

                        apiBlock.styles = JSON.stringify(styles);
                        apiBlock.id = block.id;
                        apiBlock.customStyleId = styles && Number.isInteger(styles.styleState) ? styles.styleState : null;
                        apiBlock.type = briefingBlockTypeEnumToApi.get(block.type.key as BriefingBlockTypeEnum);

                        apiBlocks.push(apiBlock);

                        break;

                    case BriefingBlockTypeEnum.DATE:
                        const dateDisplayElement = block.displayElement as DateDisplayElementModel;

                        // Default to 0 because the api uses 0 to mean "send date".
                        let timestamp: number = 0;
                        if (dateDisplayElement.date) {
                            // Get the timestamp from the date object and convert it to UTC timezone.
                            timestamp = dateDisplayElement.date - (new Date().getTimezoneOffset() * 1000 * 60);
                        }

                        // hack @TODO NEP-3392
                        styles = dateDisplayElement.styles.toBlockStyle();
                        styles.isBoundToGlobalStyles = dateDisplayElement.isBoundToGlobalStyles;
                        // endhack

                        // Only persist a date query that actually has a type; an empty/typeless
                        // object would serialize to `{}` and corrupt the saved block.
                        const serializedDateQuery: SearchCriteriaDateQueryModel =
                            DateQueryModel.toSearchCriteria(dateDisplayElement.dateQuery);

                        apiBlocks.push({
                            id: block.id,
                            type: briefingBlockTypeEnumToApi.get(block.type.key as BriefingBlockTypeEnum),
                            styles: JSON.stringify(styles),
                            timestamp: timestamp,
                            format: dateDisplayElement.format,
                            customStyleId: styles && Number.isInteger(styles.styleState) ? styles.styleState : null,
                            date: styles ? styles.date : null,
                            dateQuery: serializedDateQuery,
                            dateRangeType: dateDisplayElement.dateRangeType
                        } as BriefingDateDisplayElementApiModel);

                        break;

                    case BriefingBlockTypeEnum.DIVIDER:
                        const dividerDisplayElement = block.displayElement as DividerDisplayElementModel;

                        // hack @TODO NEP-3392
                        styles = dividerDisplayElement.styles.toBlockStyle();
                        styles.isBoundToGlobalStyles = dividerDisplayElement.isBoundToGlobalStyles;
                        // endhack

                        apiBlocks.push({
                            id: block.id,
                            type: briefingBlockTypeEnumToApi.get(block.type.key as BriefingBlockTypeEnum),
                            styles: JSON.stringify(styles),
                            customStyleId: styles && Number.isInteger(styles.styleState) ? styles.styleState : null
                        } as BriefingDividerDisplayElementApiModel);

                        break;

                    case BriefingBlockTypeEnum.AUTOMATIC_MENTION_LIST:
                        const dynamicDisplayElement = block.displayElement as DynamicMentionListDisplayElementModel;

                        // hack @TODO NEP-3392
                        styles = dynamicDisplayElement.styles.toBlockStyle();
                        styles.isBoundToGlobalStyles = dynamicDisplayElement.isBoundToGlobalStyles;
                        // endhack

                        let precisionPayload: PrecisionClipApi = null;

                        if (!!dynamicDisplayElement.additionalSettings.precisionClip) {
                            precisionPayload = {
                                keywords: dynamicDisplayElement.additionalSettings.precisionClip.manualKeywords,
                                isSavedMentionKeywords: dynamicDisplayElement.additionalSettings.precisionClip.savedMentionKeywords,
                                fallbackKeywords: dynamicDisplayElement.additionalSettings.precisionClip.fallbackKeywords,
                                isGenerateInsights: dynamicDisplayElement.additionalSettings.precisionClip.generateInsights,
                                extendedStart: dynamicDisplayElement.additionalSettings.precisionClip.extendedStart,
                                extendedEnd: dynamicDisplayElement.additionalSettings.precisionClip.extendedEnd
                            };
                        }


                        // TODO: map sort and page size, and add search criteria later
                        apiBlocks.push({
                            id: block.id,
                            type: briefingBlockTypeEnumToApi.get(block.type.key as BriefingBlockTypeEnum),
                            styles: JSON.stringify(styles),
                            title: dynamicDisplayElement.title,
                            filterSearchCriteriaId: dynamicDisplayElement.searchCriteriaId,
                            searchCriteriaId: dynamicDisplayElement.backendDataSource.id,
                            maxNumberOfMentionsInEmail: dynamicDisplayElement.pageSize,
                            customStyleId: styles && Number.isInteger(styles.styleState) ? styles.styleState : null,
                            sourceType: dynamicDisplayElement.sourceType,
                            briefingAutoGenerateInsightRequest: dynamicDisplayElement.additionalSettings.autoGenInsight,
                            generatePrecisionClips: precisionPayload,
                            blockReferenceId: dynamicDisplayElement.blockReferenceId,
                            mentionPreviewCount: dynamicDisplayElement.mentionPreviewCount,
                            automaticallyGenerated: dynamicDisplayElement.automaticallyGenerated
                        } as unknown as BriefingAutomaticMentionListDisplayElementApiModel);

                        break;

                    case BriefingBlockTypeEnum.CURATED_MENTION_LIST:
                        // TODO: Implement this mapping once the front end model for curated mention list is done
                        const curatedDisplayElement = block.displayElement as CuratedMentionListDisplayElementModel;

                        // hack @TODO NEP-3392
                        styles = curatedDisplayElement.styles.toBlockStyle();
                        styles.isBoundToGlobalStyles = curatedDisplayElement.isBoundToGlobalStyles;
                        styles.sortBy = curatedDisplayElement.sortBy;
                        // endhack

                        const mentions: BriefingCuratedMentionDetailsApi[] = [];
                        curatedDisplayElement.mentions?.forEach(m => {
                            if (m.id) {
                                mentions.push({
                                    mentionId: m.id,
                                });
                            } else if (m.mercuryId) {
                                mentions.push({
                                    mentionId: m.mercuryId,
                                    insight: !!m.insights?.length ? m.insights[0] : undefined
                                });
                            }
                        });

                        apiBlocks.push({
                            id: block.id,
                            type: briefingBlockTypeEnumToApi.get(block.type.key as BriefingBlockTypeEnum),
                            title: curatedDisplayElement.title,
                            // B/E has a hard rule that a manual block cannot contain duplicated mentions.
                            // Ideally, we should not need to do it if everything works well, but to be safe, we dedupe it here
                            mentionIds: [...new Set(curatedDisplayElement.mentionIds)],
                            mentions,
                            searchCriteriaId: curatedDisplayElement.searchCriteriaId,
                            styles: JSON.stringify(styles),
                            customStyleId: styles && Number.isInteger(styles.styleState) ? styles.styleState : null,
                            blockReferenceId: curatedDisplayElement.blockReferenceId,
                            mentionPreviewCount: curatedDisplayElement.mentionPreviewCount,
                        } as BriefingCuratedMentionListDisplayElementApiModel);

                        break;

                    case BriefingBlockTypeEnum.TABLE_OF_CONTENT:
                        const tableOfContentDisplayElement = block.displayElement as TableOfContentDisplayElementModel;
                        styles = tableOfContentDisplayElement.styles.toBlockStyle();
                        styles.isBoundToGlobalStyles = tableOfContentDisplayElement.isBoundToGlobalStyles;
                        apiBlocks.push({
                            id: block.id,
                            type: briefingBlockTypeEnumToApi.get(block.type.key as BriefingBlockTypeEnum),
                            styles: JSON.stringify(styles),
                            settings: JSON.stringify(tableOfContentDisplayElement.settings.toApi()),
                            customStyleId: styles && Number.isInteger(styles.styleState) ? styles.styleState : null
                        } as BriefingTableOfContentDispalyElementApiModel);
                        break;

                    case BriefingBlockTypeEnum.ONE_COLUMN_LAYOUT:
                    case BriefingBlockTypeEnum.TWO_COLUMN_LAYOUT:
                    case BriefingBlockTypeEnum.THREE_COLUMN_LAYOUT:
                        const layoutDisplayElement = block.displayElement as LayoutDisplayElement;
                        styles = layoutDisplayElement.styles.toBlockStyle();
                        styles.isBoundToGlobalStyles = layoutDisplayElement.isBoundToGlobalStyles;
                        const numColumnsToApi = (block as LayoutBlock).blocks.length;
                        let paddingWidth = (layoutDisplayElement.styles.columnSpacing || 0) * Math.max(0, numColumnsToApi - 1);
                        if (layoutDisplayElement.styles.padding?.paddingOption) {
                            paddingWidth = paddingWidth + (layoutDisplayElement.styles.padding.leftPadding || 0)
                                + (layoutDisplayElement.styles.padding.rightPadding || 0);
                        } else if (layoutDisplayElement.styles.padding?.paddingOption === false) {
                            paddingWidth += (layoutDisplayElement.styles.padding.paddingAll * 2 || 0);
                        }

                        apiBlocks.push({
                            id: block.id,
                            type: briefingBlockTypeEnumToApi.get(block.type.key as BriefingBlockTypeEnum),
                            styles: JSON.stringify(styles),
                            columns: (block as LayoutBlock).blocks.map((column, index) => {
                                return {
                                    type: 'COLUMN',
                                    blocks: this.mapBlocksToApi(column, (columnWidth - paddingWidth) * parseFloat(styles.width?.[index]) / 100)
                                };
                            }),
                            customStyleId: styles && Number.isInteger(styles.styleState) ? styles.styleState : null
                        });
                        break;

                    case BriefingBlockTypeEnum.ANALYSIS:
                        const analysisDisplayElement = block.displayElement as AnalysisDisplayElementModel;

                        const analysisBlock = analysisDisplayElement.toApiModel();
                        analysisBlock.id = block.id;
                        analysisBlock.type = briefingBlockTypeEnumToApi.get(block.type.key as BriefingBlockTypeEnum);

                        apiBlocks.push(analysisBlock);
                        break;

                    case BriefingBlockTypeEnum.LINK:
                        const linkDisplayElement = block.displayElement as LinkDisplayElementModel;
                        styles = linkDisplayElement.styles.toBlockStyle();
                        styles.isBoundToGlobalStyles = linkDisplayElement.isBoundToGlobalStyles;
                        apiBlocks.push({
                            type: briefingBlockTypeEnumToApi.get(block.type.key as BriefingBlockTypeEnum),
                            styles: JSON.stringify(styles),
                            links: linkDisplayElement.links.map(link => link.toApi()),
                            customStyleId: styles && Number.isInteger(styles.styleState) ? styles.styleState : null
                        } as BriefingLinkDisplayElementApiModel);
                        break;

                    case BriefingBlockTypeEnum.CHART:
                        const briefingChartDisplayElement = block.displayElement as BriefingChartDisplayElementModel;
                        const reportChartDisplayElement = briefingChartDisplayElement.chartBlock?.displayElement as ChartDisplayElementModel;
                        styles = briefingChartDisplayElement.styles.toBlockStyle();
                        styles.accentColor = briefingChartDisplayElement.styles.accentColor;
                        styles.isBoundToGlobalStyles = briefingChartDisplayElement.isBoundToGlobalStyles;
                        styles.widthPercent = briefingChartDisplayElement.chart.widthPercent;
                        if (
                            briefingChartDisplayElement.chart.generateOnSend &&
                            briefingChartDisplayElement?.chart?.chartUrl
                        ) {
                            delete briefingChartDisplayElement.chart.chartUrl;
                        }

                        const chartDisplayElement = briefingChartDisplayElement?.chartBlock?.displayElement as ChartDisplayElementModel;
                        chartDisplayElement?.series?.forEach(series => series.cacheResult = !briefingChartDisplayElement.chart.generateOnSend);

                        const chartApiBlock = {
                            id: block.id,
                            customStyleId: styles && Number.isInteger(styles.styleState) ? styles.styleState : null,
                            type: briefingBlockTypeEnumToApi.get(block.type.key as BriefingBlockTypeEnum),
                            styles: JSON.stringify(styles),
                            chartUrl: briefingChartDisplayElement.chart.chartUrl,
                            generateOnSend: briefingChartDisplayElement.chart.generateOnSend,
                            chartOptions: JSON.stringify(briefingChartDisplayElement.toChartOptionsApi()),
                            showPreviousPeriod: reportChartDisplayElement?.chartHeaderSettings?.previousPeriod,
                            searches: briefingChartDisplayElement.toSearchesApi(),
                            imageProperties: {
                                url: briefingChartDisplayElement.url ? briefingChartDisplayElement.url : '',
                                width: briefingChartDisplayElement.chart.widthPx,
                                caption: briefingChartDisplayElement.settings?.caption,
                                altText: briefingChartDisplayElement.settings?.altText,
                                displaySize: briefingChartDisplayElement.chart?.heightPx,
                            },
                            sources: briefingChartDisplayElement.toSourcesApi()
                        };
                        if (forClone) {
                            chartApiBlock['mentionSearches'] = briefingChartDisplayElement.mentionSearches;
                        }

                        apiBlocks.push(chartApiBlock);
                        break;

                    case BriefingBlockTypeEnum.COVERAGE_CURATOR:
                        const curatorBlock = block as CuratorBlock;
                        const curatorDisplayElement = curatorBlock.displayElement;
                        styles = curatorDisplayElement.styles.toBlockStyle();
                        styles.isBoundToGlobalStyles = curatorDisplayElement.isBoundToGlobalStyles;

                        const originalBlocks = curatorBlock.originalBlocks?.length ?
                            JSON.stringify(this.mapBlocksToApi(curatorBlock.originalBlocks)) : null;

                        const bulkAnalysisMessage = curatorDisplayElement.bulkAnalysisMessage.toApiModel().bulkAnalysisMessage;
                        if (bulkAnalysisMessage?.aiAnalysisType !== AiAnalysisTypes.COLLECTION_KEY_MESSAGES_DEFAULT) {
                            bulkAnalysisMessage.numberMentions = 20;
                            curatorBlock.blocks.forEach(item => {
                                if (item.type.key === BriefingBlockTypeEnum.AUTOMATIC_MENTION_LIST && item.displayElement.automaticallyGenerated) {
                                    bulkAnalysisMessage.numberMentions = (item.displayElement as DynamicMentionListDisplayElementModel).pageSize;
                                }
                            });
                        }

                        apiBlocks.push({
                            id: block.id,
                            type: briefingBlockTypeEnumToApi.get(block.type.key as BriefingBlockTypeEnum),
                            styles: JSON.stringify(styles),
                            filterSearchCriteriaId: curatorDisplayElement.searchCriteriaId,
                            searchCriteriaId: curatorDisplayElement.backendDataSource?.id,
                            customStyleId: styles && Number.isInteger(styles.styleState) ? styles.styleState : null,
                            sourceType: curatorDisplayElement.sourceType,
                            blocks: this.mapBlocksToApi((block as CuratorBlock).blocks),
                            searches: [{
                                searchCriteriaId: curatorDisplayElement.backendDataSource?.id,
                                filterSearchCriteriaId: curatorDisplayElement.searchCriteriaId,
                                sourceType: monitoringSeriesTypeEnumToMentionSourceApiTypesEnum.get(curatorDisplayElement.backendDataSource?.type)
                            } as BriefingSearchApi],
                            bulkAnalysisMessage,
                            generateOnSend: curatorDisplayElement.generateOnSend,
                            originalBlocks
                        } as unknown as BriefingCoverageCuratorDisplayElementApiModel);
                        break;
                    default:
                        // Unknown block type, do nothing
                        break;
                }
            }
        );

        apiBlocks.forEach(
            block => {
                if (!block.id) {
                    delete block.id;
                }
            }
        );

        return apiBlocks;
    }

    /**
     * Setter for global styles
     */
    setGeneralStyles(styles: any): void {
        this.generalStyles.setStyles(styles);
    }

    /**
     * Deep iterates over the defaultStyle passed in and if any of the fields on defaultStyle are null or undefined on target, sets them to the default value
     */
    setDefaultStyles(defaultStyle: any, target: any): void {
        for (const field in defaultStyle) {
            if (
                !defaultStyle.hasOwnProperty(field) ||
                field === 'styleState' ||
                field === 'displayStyleState'
            ) {
                continue;
            }
            if (defaultStyle[field] !== null && typeof defaultStyle[field] === 'object' && !(defaultStyle[field] instanceof Array)) {
                if (!target[field]) {
                    target[field] = {};
                }
                this.setDefaultStyles(defaultStyle[field], target[field]);
                continue;
            }
            if (target[field] === undefined || target[field] === null) {
                target[field] = defaultStyle[field];
            }
        }
    }

    /**
     * Gets the style state of a style object, two special rules:
     * 1. legacy value of `default` becomes `BRIEFING_1`
     * 2. if the value is `custom` or a number, need to look at the defaultReference field instead, if it exists
     * 3. if the defaultReference is blank, it's an style created before defaultReference, which means it was using BRIEFING_1
     */
    getDefaultStyleState(style: any): string {
        let styleState = BriefingStyleStateEnum.BRIEFING_1;

        // One of the default templates
        if (
            style?.styleState &&
            style.styleState !== StyleStateEnum.DEFAULT &&
            style.styleState !== StyleStateEnum.CUSTOM &&
            isNaN(Number(style.styleState))
        ) {
            styleState = style.styleState;
        } else if (style?.defaultReference) {
            // old legacy data won't have a default reference, so keep BRIEFING_1 for those
            styleState = style.defaultReference;
        }

        if (!BriefingModel.defaultBriefingStyles[styleState]) {
            styleState = BriefingStyleStateEnum.BRIEFING_1;
        }

        return styleState;
    }

    /**
     * Delivery Options
     */

    setSelectedDeliveryOptions(): void {
        this.selectedDeliveryOption.email = false;
        this.selectedDeliveryOption.rssFeed = false;

        if (this.id) {
            if (this.subject || this.mailingListIds?.length || this.recipientList?.length) {
                this.selectedDeliveryOption.email = true;
            } else {
                this.selectedDeliveryOption.email = false;
            }

            if (this.feeds?.length !== 0) {
                this.selectedDeliveryOption.rssFeed = true;
            } else {
                this.selectedDeliveryOption.rssFeed = false;
            }
            // default option is email
            if ((!this.subject || this.mailingListIds?.length === 0 || this.recipientList?.length === 0) && this.feeds?.length === 0) {
                this.selectedDeliveryOption.email = true;
            }
        } else {
            this.selectedDeliveryOption.email = true;
        }
    }

    deliveryOptionChanged(selected: boolean, value: deliveryOptionsEnum) {
        if (value === deliveryOptionsEnum.email) {
            this.selectedDeliveryOption.email = selected;
        } else if (value === deliveryOptionsEnum.rssFeed) {
            this.selectedDeliveryOption.rssFeed = selected;
        } else {
            this.selectedDeliveryOption.digest = selected;
        }

        // Reset data when option changes
        if (!this.selectedDeliveryOption.email) {
            if (this.deliveryMethod === BriefingDeliveryMethodEnum.EMAIL) {
                this.subject = null;
            }
            this.previewText = null;
            this.mailingListIds = [];
            this.recipientList = [];
        }
        if (!this.selectedDeliveryOption.rssFeed) {
            this.feeds = [];
        }
    }

    getFeedIds(): number[] {
        return this.feeds?.map(x => x.id);
    }

    setFeedNameAndUrl(rssFeeds: RSSFeed[]): void {
        if (!this.feeds?.length || !rssFeeds?.length) {
            return;
        }

        this.feeds.forEach(feed => {
            const findItem = rssFeeds.find(x => x?.id === feed.id);
            feed.setNameAndUrl(findItem?.name, findItem?.url);
        });
    }

    /**
     * Parse through chart blocks, returning a collection of all mention series
     * Mention series = [Folder, Topic, Tag, TagGroup, SourceGroup, Subscription]
     */
    getChartMentionsSeries(selectedBlock?: BlockModel): ReportSeriesModel[] {
        const series: ReportSeriesModel[] = [];
        const blocks = [];
        const selectedBlocks = selectedBlock ? [selectedBlock] : this.blocks;
        selectedBlocks.forEach(block => {
            if (block.isLayoutBlockType()) {
                (block as LayoutBlock).blocks.forEach(column => {
                    column.forEach(x => {
                        if (x.type.key === BriefingBlockTypeEnum.CHART) {
                            blocks.push(x);
                        }
                    });
                });
            } else {
                if (block.type.key === BriefingBlockTypeEnum.CHART) {
                    blocks.push(block);
                }
            }
        });

        for (const block of blocks) {
            const briefingChartDisplayElement = block.displayElement as BriefingChartDisplayElementModel;
            const chartDisplayElement = briefingChartDisplayElement?.chartBlock?.displayElement as ChartDisplayElementModel;
            const mentionSeries = chartDisplayElement?.getMentionSeries();
            if (mentionSeries) {
                mentionSeries.forEach(x => {
                    x.timeInterval = chartDisplayElement?.timeInterval;
                    x.metric = chartDisplayElement?.metric;
                    x.metrics = chartDisplayElement?.metrics;
                    x.hasPreviousPeriod = chartDisplayElement?.styles?.chartDisplaySettings?.previousPeriod;
                });
                series.push(...mentionSeries);
            }
        }

        return series;
    }

    /**
     * Parse through chart blocks, returning a collection of all social series
     * Social series = [Theme, SocialTopic (agent)]
     */
    getChartSocialSeries(selectedBlock?: BlockModel): ReportSeriesModel[] {
        const series: ReportSeriesModel[] = [];
        const blocks = [];
        const selectedBlocks = selectedBlock ? [selectedBlock] : this.blocks;
        selectedBlocks.forEach(block => {
            if (block.isLayoutBlockType()) {
                (block as LayoutBlock).blocks.forEach(column => {
                    column.forEach(x => {
                        if (x.type.key === BriefingBlockTypeEnum.CHART) {
                            blocks.push(x);
                        }
                    });
                });
            } else {
                if (block.type.key === BriefingBlockTypeEnum.CHART) {
                    blocks.push(block);
                }
            }
        });

        for (const block of blocks) {
            const briefingChartDisplayElement = block.displayElement as BriefingChartDisplayElementModel;
            const chartDisplayElement = briefingChartDisplayElement?.chartBlock?.displayElement as ChartDisplayElementModel;
            const socialSeries = chartDisplayElement?.getSocialSeries();
            if (socialSeries) {
                socialSeries.forEach(x => {
                    x.timeInterval = chartDisplayElement?.timeInterval;
                    x.metric = chartDisplayElement?.metric;
                    x.metrics = chartDisplayElement?.metrics;
                    x.hasPreviousPeriod = chartDisplayElement?.styles?.chartDisplaySettings?.previousPeriod;
                });
                series.push(...socialSeries);
            }
        }

        return series;
    }

    /**
     * Parse through chart blocks, returning a collection of all external series.
     * External series = [Google Analytics]
     */
    getChartExternalDataSeries(selectedBlock?: BlockModel): ReportSeriesModel[] {
        const series: ReportSeriesModel[] = [];
        const blocks = [];
        const selectedBlocks = selectedBlock ? [selectedBlock] : this.blocks;
        selectedBlocks.forEach(block => {
            if (block.isLayoutBlockType()) {
                (block as LayoutBlock).blocks.forEach(column => {
                    column.forEach(x => {
                        if (x.type.key === BriefingBlockTypeEnum.CHART) {
                            blocks.push(x);
                        }
                    });
                });
            } else {
                if (block.type.key === BriefingBlockTypeEnum.CHART) {
                    blocks.push(block);
                }
            }
        });

        for (const block of blocks) {
            const briefingChartDisplayElement = (block.displayElement as BriefingChartDisplayElementModel);
            const externalDataSeries = (briefingChartDisplayElement?.chartBlock?.displayElement as ChartDisplayElementModel)?.getExternalDataSeries();
            if (externalDataSeries) {
                series.push(...externalDataSeries);
            }
        }

        return series;
    }

    getChartBlocksWithoutData(): BlockModel[] {
        let blocks = [];
        this.blocks?.forEach(b => {
            if (b.isLayoutBlockType()) {
                (b as LayoutBlock).blocks.forEach(column => {
                    column.forEach(x => blocks.push(x));
                });
            } else {
                blocks.push(b);
            }
        });
        blocks = blocks.filter(block => {
            if (block.type.key === BriefingBlockTypeEnum.CHART) {
                const series = ((block.displayElement as BriefingChartDisplayElementModel).chartBlock?.displayElement as ChartDisplayElementModel)?.series;

                if (series?.length) {
                    // A block still needs a data fetch if ANY of its series is missing data.
                    // Previously this used `!series.some(hasData)` ("skip once at least one series has data"),
                    // which wrongly treated a multi-series competitive chart as fully loaded when only the
                    // primary series had stored data - leaving the competitor series (whose data was never
                    // stored) stuck loading forever.
                    return series.some(item => !item.dataProvider.getValue());
                }
            }

            return false;
        });

        return blocks;
    }

    cacheMentionWithAutoGenInsight(mentionWithAutoGenInsight: BriefingCuratedMentionDetailsApi): void {
        if (!mentionWithAutoGenInsight.blockReferenceId) {
            // briefing level, change mentions in all blocks to the same insight
            this.cachedMentionsWithInsight = this.cachedMentionsWithInsight.filter(item => {
                return item.mentionId !== mentionWithAutoGenInsight.mentionId;
            });
            this.cachedMentionsWithInsight.push(mentionWithAutoGenInsight);
        } else {
            if (this.cachedMentionsWithInsight.some(item =>
                item.mentionId === mentionWithAutoGenInsight.mentionId
                && item.blockReferenceId === mentionWithAutoGenInsight.blockReferenceId)
            ) {
                const mention = this.cachedMentionsWithInsight.find(item =>
                    item.mentionId === mentionWithAutoGenInsight.mentionId
                    && item.blockReferenceId === mentionWithAutoGenInsight.blockReferenceId);

                mention.insight = mentionWithAutoGenInsight.insight;
            } else {
                this.cachedMentionsWithInsight.push(mentionWithAutoGenInsight);
            }
        }
    }

    getAllCuratedBlocks(): BlockModel[] {
        const curatedBlocks = [];
        this.blocks.forEach(block => {
            if (block.type.key === LayoutBlockTypesEnum.briefingOne) {
                (block as LayoutBlock).blocks.forEach(column => {
                    column.forEach(x => {
                        if (x.type?.key === BriefingBlockTypeEnum.CURATED_MENTION_LIST) {
                            curatedBlocks.push(x);
                        }
                    });
                });
            } else if (block.type.key === BriefingBlockTypeEnum.COVERAGE_CURATOR) {
                (block as CuratorBlock).blocks.forEach(x => {
                    if (x.type?.key === BriefingBlockTypeEnum.CURATED_MENTION_LIST) {
                        curatedBlocks.push(x);
                    }
                });
            } else {
                if (block.type?.key === BriefingBlockTypeEnum.CURATED_MENTION_LIST) {
                    curatedBlocks.push(block);
                }
            }
        });

        return curatedBlocks;
    }
}
